import React from "react";
import { InfoWindow } from "@react-google-maps/api";
import authHeaders from "../utilities/authHeaders";
import makeRequest from "../utilities/makeRequest";
import notification from "../utilities/notification";

const ConfirmationInfoWindow = ({
  latitude,
  longitude,
  newPost,
  postId,
  posts,
  setLocationMode,
  setNewPostMode,
  setNotificationId,
  setPosts,
  setSelected,
}) => {
  const handleConfirmation = () => {
    const url = `${process.env.REACT_APP_HOST}/api/v1/posts/${postId}`;
    const method = "PATCH";
    let today = new Date().toISOString().slice(0, 10);
    const formData = new FormData();
    formData.append("post[timestamp]", today);
    formData.append("post[latitude]", latitude);
    formData.append("post[longitude]", longitude);

    makeRequest(url, method, formData, authHeaders())
      .then((response) => {
        if (response.ok) {
          response.json().then(() => {
            setNewPostMode(false);
            setLocationMode(false);
            notification("Post created!", "success", 3000);
            setSelected(newPost);
          });
        } else {
          response.json().then((data) => {
            console.error("Error:", data);
          });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const handleCancellation = () => {
    const filteredPosts = posts.filter((post) => post.id !== postId);
    setPosts(filteredPosts);
    setNewPostMode(false);
    const id = notification(
      "Click anywhere on the map to add location",
      "info",
      0
    );
    setNotificationId(id);
  };

  return (
    <InfoWindow
      position={{
        lat: parseFloat(latitude),
        lng: parseFloat(longitude),
      }}
    >
      <div className="confirmation-window">
        <p className="confirmation">Confirm location?</p>
        <div className="confirm">
          <div className="btn-container">
            <button
              className="auth-btn"
              id="confirm-btn"
              onClick={handleConfirmation}
            >
              Confirm
            </button>
          </div>
          <div className="btn-container">
            <button
              className="auth-btn"
              id="confirm-btn"
              onClick={handleCancellation}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </InfoWindow>
  );
};

export default ConfirmationInfoWindow;
